import React from "react";
import { View, Pressable, Text, StyleSheet } from "react-native";
import color from "@constants/color";
import t from "@constants/localization";

const PATH = "screens/MyTask";

function RescheduleRightComponent({ setRescheduledModal, isRescheduled }) {
  return typeof isRescheduled === "boolean" ? (
    <View>
      <Pressable
        onPress={() => {
          setRescheduledModal(true);
        }}
      >
        {isRescheduled ? (
          <View
            style={[
              styles.rescheduleBtnContainer,
              {
                borderColor: color.skyBlue2,
                backgroundColor: color.white,
              },
            ]}
          >
            <Text
              style={[
                styles.rescheduleBtnText,
                {
                  color: color.skyBlue2,
                },
              ]}
            >
              {t(`${PATH}/cancel_reschedule_btn`)}
            </Text>
          </View>
        ) : (
          <View
            style={[
              styles.rescheduleBtnContainer,
              {
                borderColor: "rgba(105, 150, 255, 1)",
                backgroundColor: "rgba(243, 246, 255, 1)",
              },
            ]}
          >
            <Text
              style={[
                styles.rescheduleBtnText,
                {
                  color: "rgba(61, 119, 255, 1)",
                },
              ]}
            >
              {t(`${PATH}/reschedule_btn`)}
            </Text>
          </View>
        )}
      </Pressable>
    </View>
  ) : null;
}

export default RescheduleRightComponent;

const styles = StyleSheet.create({
  rescheduleBtnContainer: {
    paddingVertical: 5,
    paddingHorizontal: 15,
    paddingBottom: 7,
    elevation: 5,
    borderWidth: 1,
    borderRadius: 20,
  },
  rescheduleBtnText: {
    textAlign: "center",
    fontWeight: "bold",
  },
});
